import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Alert, FormControl, FormLabel } from "@mui/material";
import AddRounded from "@mui/icons-material/AddRounded";
import DeleteOutlineRounded from "@mui/icons-material/DeleteOutlineRounded";
import { MonitorButton, MonitorInput } from "./MonitorControls";
import "./RuntimeLocationsField.css";

export default function RuntimeLocationsField({ value = [], inherited = false, sourceName, error, onChange }) {
  const { t } = useTranslation("space");
  const id = useId();
  const rows = Array.isArray(value) ? value : [];
  const update = (index, field, next) => onChange(rows.map((row, i) => i === index
    ? { ...(typeof row === "string" ? { name: row, locationId: row } : row), [field]: next } : row));
  return <section className="runtime-locations-field" aria-labelledby={`${id}-title`}>
    <h3 id={`${id}-title`}>{t("edge.deployTitel")}</h3>
    <p className="runtime-locations-help">{t("edge.deployInfo")}</p>
    {inherited && <Alert severity={error ? "warning" : "info"} className="runtime-locations-inherited">
      {t(error ? "edge.inheritanceError" : sourceName ? "edge.inheritedFrom" : "edge.inherited", { name: sourceName })}
    </Alert>}
    {!rows.length && <p className="runtime-locations-help">{t(inherited ? "edge.inheritedEmpty" : "edge.empty")}</p>}
    {rows.map((entry, index) => {
      const row = typeof entry === "string" ? { name: entry, locationId: entry } : entry || {};
      return <div className={`runtime-location-row${inherited ? " is-inherited" : ""}`} key={index}>
        {[["name", "deployName"], ["locationId", "deployLocation"]].map(([field, label]) =>
          <FormControl key={field} fullWidth>
            <FormLabel htmlFor={`${id}-${field}-${index}`}>{t(`edge.${label}`)}</FormLabel>
            <MonitorInput id={`${id}-${field}-${index}`} aria-label={t(`edge.${label}`)}
              readOnly={inherited} value={row[field] || ""} maxLength={field === "name" ? 200 : 160}
              placeholder={t(`edge.${label}Platzhalter`)} onChange={event => update(index, field, event.target.value)}/>
          </FormControl>)}
        {!inherited && <MonitorButton className="iconbtn" title={t("edge.deployEntfernen")}
          onClick={() => onChange(rows.filter((_, i) => i !== index))}><DeleteOutlineRounded/></MonitorButton>}
      </div>;
    })}
    {!inherited && <MonitorButton variant="outlined" startIcon={<AddRounded/>}
      onClick={() => onChange([...rows, { name: "", locationId: "" }])}>{t("edge.deployHinzufuegen")}</MonitorButton>}
    <p className="runtime-locations-help">{t(inherited ? "edge.projectIdentity" : "edge.inheritanceHint")}</p>
  </section>;
}
